import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { AppSidebarNav } from './AppSidebarNav'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config - now uses dynamic navigation
import { getNavigation } from '../_nav'
import { logoBZ } from 'src/assets/brand/logo-bz'

// Custom event for navigation refresh
export const refreshNavigation = () => {
  window.dispatchEvent(new CustomEvent('navigation-refresh'))
}

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [nav, setNav] = useState([])
  const [userLogo, setUserLogo] = useState(null)

  // Function to update navigation
  const updateNavigation = () => {
    const userNav = getNavigation()
    setNav(userNav)

    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const userObj = JSON.parse(userStr);
        if (userObj?.logo) {
          const logoPath = userObj.logo;
          const fullLogoUrl = logoPath.startsWith('http') || logoPath.startsWith('data:')
            ? logoPath
            : `${process.env.REACT_APP_BACKEND}/${logoPath}`;
          setUserLogo(fullLogoUrl);
        } else {
          setUserLogo(null);
        }
      } else {
        setUserLogo(null);
      }
    } catch (error) {
      console.error("Error parsing user data for logo:", error);
      setUserLogo(null);
    }
  }

  useEffect(() => {
    // Initial navigation load
    updateNavigation()
  }, [])

  // Re-evaluate navigation when localStorage changes (login/logout)
  useEffect(() => {
    const handleStorageChange = () => {
      updateNavigation()
    }

    // Listen for storage changes (other tabs)
    window.addEventListener('storage', handleStorageChange)

    // Listen for custom navigation refresh (same tab login)
    window.addEventListener('navigation-refresh', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('navigation-refresh', handleStorageChange)
    }
  }, [])

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {userLogo ? (
          <img src={userLogo} alt="User Logo" height={35} style={{ objectFit: 'contain', padding: '5px', maxWidth: '100%' }} />
        ) : (
          <>
            <CIcon className="sidebar-brand-full" icon={logoBZ} height={25} />
            <CIcon className="sidebar-brand-narrow" icon={logoBZ} height={25} />
          </>
        )}
      </CSidebarBrand>

      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={nav} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)